export const environment = {
  prod: true,
  apiUrl: 'https://sbpay-api.bajiexch365.com/api',
  cryptoSecret: 'ASgO-57!,xdFhKjA',
  env: 'Staging',
};
